// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../icons/dropdown.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.select[data-id] {
  height: 40px;
  position: relative;
  color: #ffffff;
  width: 196px;
  font-size: 20px;
}
.select[data-id] .value {
  position: relative;
  z-index: 1;
  display: inline-block;
  width: 100%;
  height: 100%;
  padding-inline: 28px 35px;
  display: flex;
  align-items: center;
  transition: all 0.5s ease-in-out;
  font-size: 14px;
  cursor: pointer;
}
.select[data-id] .value .select-placeholder {
  width: 100%;
  color: #afafaf;
}
.select[data-id] .value span {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.select[data-id] .center-placeholder .select-placeholder {
  text-align: center !important;
}
.select[data-id]:not(:focus) .select-placeholder {
  transition-delay: 0.6s;
}
.select[data-id] .optList {
  position: relative;
  top: -36px;
  z-index: 1;
  padding-inline-start: 16px;
  list-style-type: none;
  opacity: 0;
  width: calc(100% - 35px);
  height: 0;
  max-height: 190px;
  overflow-y: scroll;
  -ms-overflow-style: none;
  /* IE and Edge */
  scrollbar-width: none;
  /* Firefox */
  transition: all 0.3s ease-in-out;
  margin-inline: 1px;
  margin-block: -1px;
  font-size: 14px;
}
.select[data-id] .optList::-webkit-scrollbar {
  display: none;
}
.select[data-id] .optList .option {
  height: 0;
  opacity: 0;
  cursor: pointer;
  padding-left: 12px;
  scale: 1 0;
  transition: scale 0.1s ease-in-out 0.3s;
  display: inline-block;
  vertical-align: middle;
  line-height: 38px;
}
.select[data-id] .optList.selected {
  top: 0px;
  max-height: 152px;
  overflow-y: scroll;
}
.select[data-id] .icon {
  width: 16px;
  height: 16px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-size: cover;
  z-index: 1;
  position: absolute;
  top: 10px;
  left: calc(100% - 35px);
  transform-origin: center;
  transition: all 0.5s ease-in-out;
  transform: rotate(90deg);
}
.select[data-id] .select-box {
  position: absolute;
  width: 100%;
  height: 100%;
  max-height: 200px;
  overflow-y: hidden;
  background-color: rgba(122, 115, 115, 0.5);
  clip-path: polygon(calc(100% - 12px) 100%, 100% calc(100% - 12px), 100% 12px, calc(100% - 12px) 0%, 12px 0%, 0% 12px, 0% calc(100% - 12px), 12px 100%);
  z-index: 0;
  transition: all 0.5s ease-in-out;
}
.select[data-id] .select-box::before {
  content: "";
  position: absolute;
  background-color: #000000;
  clip-path: polygon(calc(100% - 12px) 100%, 100% calc(100% - 12px), 100% 12px, calc(100% - 12px) 0%, 12px 0%, 0% 12px, 0% calc(100% - 12px), 12px 100%);
  inset: 1.2px 1px;
}
.select[data-id][data-disabled="1"] .value,
.select[data-id][data-disabled="1"] .icon {
  cursor: default !important;
}
.select[data-id][data-disabled="1"] .value > span {
  cursor: default !important;
}
.select[data-id]:not([data-disabled="1"]):hover .select-box {
  background-color: #24b8c0;
}
.select[data-id]:not([data-disabled="1"]):focus .select-box {
  background-color: #24b8c0;
  z-index: 3;
  height: 200px;
}
.select[data-id]:not([data-disabled="1"]):focus .value {
  z-index: 3;
}
.select[data-id]:not([data-disabled="1"]):focus .value .select-placeholder {
  visibility: hidden;
}
.select[data-id]:not([data-disabled="1"]):focus .optList {
  opacity: 1;
  height: auto;
  z-index: 3;
}
.select[data-id]:not([data-disabled="1"]):focus .optList .option {
  opacity: 1;
  height: 38px;
  scale: 1 1;
}
.select[data-id]:not([data-disabled="1"]):focus .icon {
  transform: rotate(0deg);
  z-index: 3;
}
.select[data-id]:not([data-disabled="1"]):focus .select-box-1 {
  height: 40px;
}
.select[data-id]:not([data-disabled="1"]):focus .select-box-2 {
  height: 80px;
}
.select[data-id]:not([data-disabled="1"]):focus .select-box-3 {
  height: 120px;
}
.select[data-id]:not([data-disabled="1"]):focus .select-box-4 {
  height: 160px;
}
.select[data-id]:not([data-disabled="1"]):focus .select-box-5 {
  height: 200px;
}`, "",{"version":3,"sources":["webpack://./src/assets/scss/select.scss","webpack://./src/assets/scss/variables.scss"],"names":[],"mappings":"AAEA;EAKE,YAAA;EACA,kBAAA;EACA,cCHY;EDIZ,YAAA;EACA,eAAA;AALF;AAOE;EACE,kBAAA;EACA,UAAA;EACA,qBAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,gCAAA;EACA,eAAA;EACA,eAAA;AALJ;AAOI;EACE,WAAA;EACA,cC3BY;ADsBlB;AAQI;EACE,gBAAA;EACA,uBAAA;EACA,mBAAA;AANN;AAWI;EACE,6BAAA;AATN;AAcI;EACE,sBAAA;AAZN;AAgBE;EACE,kBAAA;EACA,UAAA;EACA,UAAA;EACA,0BAAA;EACA,qBAAA;EACA,UAAA;EACA,wBAAA;EACA,SAAA;EACA,iBAAA;EACA,kBAAA;EACA,wBAAA;EACA,gBAAA;EACA,qBAAA;EAEA,YAAA;EAIA,gCAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;AAlBJ;AAYI;EACE,aAAA;AAVN;AAiBI;EACE,SAAA;EACA,UAAA;EACA,eAAA;EACA,kBAAA;EACA,UAAA;EACA,uCAAA;EACA,qBAAA;EACA,sBAAA;EACA,iBAAA;AAfN;AAmBE;EACE,QAAA;EACA,iBAAA;EACA,kBAAA;AAjBJ;AAoBE;EACE,WAAA;EACA,YAAA;EACA,yDAAA;EACA,4BAAA;EACA,sBAAA;EACA,UAAA;EACA,kBAAA;EACA,SAAA;EACA,uBAAA;EACA,wBAAA;EACA,gCAAA;EACA,wBAAA;AAlBJ;AAqBE;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,0CAAA;EACA,sJAAA;EACA,UAAA;EAQA,gCAAA;AA1BJ;AAmBI;EACE,WAAA;EACA,kBAAA;EACA,yBCrHO;EDsHP,sJAAA;EACA,gBAAA;AAjBN;AAuBI;;EAEE,0BAAA;AArBN;AAuBI;EACE,0BAAA;AArBN;AA0BI;EACE,yBAAA;AAxBN;AA6BI;EACE,yBAAA;EACA,UAAA;EACA,aAAA;AA3BN;AA8BI;EACE,UAAA;AA5BN;AA6BM;EACE,kBAAA;AA3BR;AA+BI;EACE,UAAA;EACA,YAAA;EACA,UAAA;AA7BN;AA8BM;EACE,UAAA;EACA,YAAA;EACA,UAAA;AA5BR;AAgCI;EACE,uBAAA;EACA,UAAA;AA9BN;AAoCM;EACE,YAAA;AAlCR;AAiCM;EACE,YAAA;AA/BR;AA8BM;EACE,aAAA;AA5BR;AA2BM;EACE,aAAA;AAzBR;AAwBM;EACE,aAAA;AAtBR","sourcesContent":["@use \"./variables.scss\" as var;\n\n.select[data-id] {\n  // $input-path: calc(100% - 12px) 100%, 100% 75%, 100% 25%, calc(100% - 12px) 0%,\n  //   12px 0%, 0% 25%, 0% 75%, 12px 100%;\n  $input-path: calc(100% - 12px) 100%, 100% calc(100% - 12px), 100% 12px,\n    calc(100% - 12px) 0%, 12px 0%, 0% 12px, 0% calc(100% - 12px), 12px 100%;\n  height: 40px;\n  position: relative;\n  color: var.$light-color;\n  width: 196px;\n  font-size: 20px;\n\n  .value {\n    position: relative;\n    z-index: 1;\n    display: inline-block;\n    width: 100%;\n    height: 100%;\n    padding-inline: 28px 35px;\n    display: flex;\n    align-items: center;\n    transition: all 0.5s ease-in-out;\n    font-size: 14px;\n    cursor: pointer;\n\n    .select-placeholder {\n      width: 100%;\n      color: var.$secondary-color;\n    }\n\n    span {\n      overflow: hidden;\n      text-overflow: ellipsis;\n      white-space: nowrap;\n    }\n  }\n\n  .center-placeholder {\n    .select-placeholder {\n      text-align: center !important;\n    }\n  }\n\n  &:not(:focus) {\n    .select-placeholder {\n      transition-delay: 0.6s;\n    }\n  }\n\n  .optList {\n    position: relative;\n    top: -36px;\n    z-index: 1;\n    padding-inline-start: 16px;\n    list-style-type: none;\n    opacity: 0;\n    width: calc(100% - 35px);\n    height: 0;\n    max-height: calc(38px * 5);\n    overflow-y: scroll;\n    -ms-overflow-style: none;\n    /* IE and Edge */\n    scrollbar-width: none;\n\n    /* Firefox */\n    &::-webkit-scrollbar {\n      display: none;\n    }\n    transition: all 0.3s ease-in-out;\n    margin-inline: 1px;\n    margin-block: -1px;\n    font-size: 14px;\n\n    .option {\n      height: 0;\n      opacity: 0;\n      cursor: pointer;\n      padding-left: 12px;\n      scale: 1 0;\n      transition: scale 0.1s ease-in-out 0.3s;\n      display: inline-block;\n      vertical-align: middle;\n      line-height: 38px;\n    }\n  }\n\n  .optList.selected {\n    top: 0px;\n    max-height: calc(38px * 4);\n    overflow-y: scroll;\n  }\n\n  .icon {\n    width: 16px;\n    height: 16px;\n    background-image: url(\"../icons/dropdown.svg\");\n    background-repeat: no-repeat;\n    background-size: cover;\n    z-index: 1;\n    position: absolute;\n    top: 10px;\n    left: calc(100% - 35px);\n    transform-origin: center;\n    transition: all 0.5s ease-in-out;\n    transform: rotate(90deg);\n  }\n\n  .select-box {\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    max-height: calc(40px * 5);\n    overflow-y: hidden;\n    background-color: rgba(#7a7373, 0.5);\n    clip-path: polygon($input-path);\n    z-index: 0;\n    &::before {\n      content: \"\";\n      position: absolute;\n      background-color: var.$dark-color;\n      clip-path: polygon($input-path);\n      inset: 1.2px 1px;\n    }\n    transition: all 0.5s ease-in-out;\n  }\n\n  &[data-disabled=\"1\"] {\n    .value,\n    .icon {\n      cursor: default !important;\n    }\n    .value > span {\n      cursor: default !important;\n    }\n  }\n\n  &:not([data-disabled=\"1\"]):hover {\n    .select-box {\n      background-color: #24b8c0;\n    }\n  }\n\n  &:not([data-disabled=\"1\"]):focus {\n    .select-box {\n      background-color: #24b8c0;\n      z-index: 3;\n      height: calc(40px * 5);\n    }\n\n    .value {\n      z-index: 3;\n      .select-placeholder {\n        visibility: hidden;\n      }\n    }\n\n    .optList {\n      opacity: 1;\n      height: auto;\n      z-index: 3;\n      .option {\n        opacity: 1;\n        height: 38px;\n        scale: 1 1;\n      }\n    }\n\n    .icon {\n      transform: rotate(0deg);\n      z-index: 3;\n    }\n  }\n\n  @for $i from 1 through 5 {\n    &:not([data-disabled=\"1\"]):focus {\n      .select-box-#{$i} {\n        height: calc(40px * $i);\n      }\n    }\n  }\n}\n\n// .select-disabled[data-id] {\n//   .value {\n//     cursor: initial;\n//     span {\n//       cursor: initial;\n//     }\n//   }\n//   .option {\n//     cursor: initial;\n//   }\n//   .icon {\n//     cursor: initial;\n//   }\n//   &:hover {\n//     .select-box {\n//       background-color: rgba(#7a7373, 0.5);\n//     }\n//   }\n//   &:focus {\n//     .select-box {\n//       background-color: rgba(#7a7373, 0.5);\n//       z-index: 0;\n//       height: inherit;\n//     }\n\n//     .value {\n//       z-index: 1;\n//       .select-placeholder {\n//         visibility: visible;\n//       }\n//     }\n\n//     .optList {\n//       opacity: 0;\n//       height: 0;\n//       z-index: 1;\n//       .option {\n//         height: 0;\n//         opacity: 0;\n//         cursor: initial;\n//       }\n//     }\n\n//     .icon {\n//       transform: rotate(90deg);\n//       z-index: 1;\n//     }\n//   }\n// }\n","$primary-color: #f27a43; //#24b8c0\n$secondary-color: #afafaf; //#f634f2\n$danger-color: #ff0000;\n$dark-color: #000000;\n$highlight-color: #dcc97e;\n\n$light-color: #ffffff;\n$btn-primary-color: linear-gradient(270deg, #ed541d 0%, #f4901b 100%);\n\n$sm-screen: '640px';\n$md-screen: '768px';\n$lg-screen: '1024px';\n$xl-screen: '1280px';\n$xxl-screen: '1536px';\n\n//fonts\n$font-gkktt: '851ゴチカクット';\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
